import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";

import { AppEnvironmentConfig, Application } from "../../constants/AppConfigs";

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();
let appInsights: ApplicationInsights;
let loggedInUserId: number | null = null;

const loadInsights = (key: string) => {
  if (!key) {
    return;
  }
  appInsights = new ApplicationInsights({
    config: {
      connectionString: key,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
      },
      enableAutoRouteTracking: true,
    },
  });
  appInsights.loadAppInsights();

  // Attach global telemetry properties
  appInsights.addTelemetryInitializer((envelope) => {
    const telemetryItem = envelope.baseData as any;
    telemetryItem.properties = {
      ...telemetryItem.properties,
      application: Application, // Identifies this as HealthPlanPortalUI logs
      environment: AppEnvironmentConfig.DEV, // Tracks deployment environment
      userId: loggedInUserId, // Tracks authenticated user (if available)
      currentRoute: window.location.pathname, // Captures current React route
    };
  });
};


/**
 * Sets the authenticated user ID to attach to subsequent telemetry (pass null to clear).
 */
const setUserId = (userId: number) => {
  if (userId) {
    loggedInUserId = userId;
  }
};

export { reactPlugin, appInsights, loadInsights, setUserId };
